import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-是",
  "use": "icon-是-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-是\">\n<circle cx=\"80.4\" cy=\"79.6\" r=\"65.8\" stroke=\"#5691F2\" stroke-width=\"10\" />\n<circle cx=\"80.5\" cy=\"79.5\" r=\"36.5\" fill=\"#5691F2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/是.svg
// module id = kmjW
// module chunks = 26